import { runClientComponent } from '../../_common/client/client-component-runner';
import { SponsoredContentAlternativeComponent } from './sponsored-content-alternative.component';

runClientComponent({ SponsoredContentAlternativeComponent });
